var map = {
	"./xmsb1.png": "3358",
	"./xmsb10.png": "3996",
	"./xmsb11.png": "98b6",
	"./xmsb12.png": "a0d0",
	"./xmsb2.png": "d1b6",
	"./xmsb3.png": "5c50",
	"./xmsb4.png": "9a34",
	"./xmsb5.png": "690c",
	"./xmsb6.png": "02dd",
	"./xmsb7.png": "e7ea",
	"./xmsb8.png": "21ae",
	"./xmsb9.png": "b6d1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5283";